import _Accordion from './Accordion';
import AccordionPanel from './AccordionPanel';

const Accordion = Object.assign(_Accordion, { AccordionPanel });
export default Accordion;
